import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'semantic-ui-react';

import User from '../User';

import styles from './ListTransferMissingAssigneesModal.module.scss';

const ListTransferMissingAssigneesModal = React.memo(({ open, users, onConfirm, onClose }) => {
  const [t] = useTranslation();

  const handleConfirm = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      onConfirm();
    },
    [onConfirm],
  );

  const handleClose = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      onClose();
    },
    [onClose],
  );

  return (
    <Modal
      open={open}
      size="large"
      centered
      closeOnDimmerClick={false}
      className={styles.modal}
      onClose={handleClose}
    >
      <Modal.Header>{t('common.moveList', { context: 'title' })}</Modal.Header>
      <Modal.Content>
        <p className={styles.text}>
          {t('common.listTransferMissingAssigneesDescription', {
            defaultValue:
              'В доске назначения отсутствуют следующие пользователи (исполнители). Добавить пользователей на доску?',
          })}
        </p>
        <div className={styles.usersGrid}>
          {users.map((user) => (
            <div key={user.id} className={styles.userItem}>
              <User name={user.name} avatarUrl={user.avatarUrl} size="small" />
              <span className={styles.userName}>{user.name}</span>
            </div>
          ))}
        </div>
      </Modal.Content>
      <Modal.Actions className={styles.actions}>
        <Button type="button" onClick={handleClose}>
          {t('action.cancel', { defaultValue: 'Отмена' })}
        </Button>
        <Button type="button" positive onClick={handleConfirm}>
          {t('action.add', { defaultValue: 'Добавить' })}
        </Button>
      </Modal.Actions>
    </Modal>
  );
});

ListTransferMissingAssigneesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string,
    }),
  ).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ListTransferMissingAssigneesModal;
